import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const rmaLatestOrders = css`
  .rma-latest-orders {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .rma-latest-orders__order {
    --cse-accordion-default-header-background-color: ${csColorBackground.primary};
    --cse-accordion-default-content-background-color: ${csColorBackground.primary};
    --cse-accordion-default-content-padding-y: 0;
    border: ${csBorder.width} solid ${csColorBorder.light};
    border-radius: ${csBorder.radiusMinimal};
  }

  .rma-latest-orders__content {
    padding-bottom: ${csSpacing.spacing06};
  }

  .rma-latest-orders__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${csSpacing.spacing08};
  }

  .rma-latest-orders__column {
    --cs-font-caption-s-text-transform: uppercase;
  }

  .rma-latest-orders__date {
    min-width: 160px;
  }
`
